export const localStorageKeys = Object({
    checkInParams: '_CheckInParams',
    checkingModule: '_CheckinModuleData',
    screenConfig: '_ScreenConfig',
    ownerDetails: '_OwnerDetails',
    privacyConsent: '_PrivacyConsent',
    additionalDetails: '_AdditionalDetails',
    servicePlanDetails:'_ServicePlanDetails',
    serviceDetails: '_ServiceDetails',
    offerValueDetails: '_OfferValueDetails',
    notifyUserDetails: '_NotifyUserDetails',
    appointmentConfirm: '_appointmentConfirm',
    clientName: '_clientName',
    stepStatus: '_stepStatus',
    logo: '_logo',
    currencyType:'_currencyType',
    unauthorizeUser: '_UnauthorizeUser',
    cdkRepairData: '_cdkRepairData',
    tinyUrl: '_tinyUrl',
    nomineeContactDetails: '_nomineeContactDetails',
    isCheckInNotAllowed : '_isCheckInNotAllowed',
    autoCarPlate : '_autoCarPlate',
    isPlanningAvailable : '_isPlanningAvailable',
});

export const screenDetails = Object({
    stepZero: 'login',
    stepOne: 'FirstStep',
    stepTwo: 'SecondStep',
    stepThree: 'ThirdStep',
    stepFour: 'FourthStep',
    stepFive: 'Advise',
    stepSix: 'CurrentOffer',
    stepSeven: 'SeventhStep'
});

export const applicationPaths = Object({
    landing: 'landing',
    login: 'login',
    // first: 'first',
    first: 'start-checkin',
    second: 'your-details',
    // third: 'third',
    third: 'terms-and-conditions',
    // fourth: 'fourth',
    fourth: 'confirmed-work',
    five: 'fifth',
    six: 'sixth',
    // seven: 'seventh',
    seven: 'thank-you',
    calldealer: 'calldealer',
    unauthorize: 'unauthorize',
    confirmationfail: 'confirmationfail',
    cookiePolicy: 'cookiePolicy'
});

export const enum KeyValue {
    DefaultLanguage = 'en-US',
    ModuleForLocalization = 'CheckIn'
}

export const checkInKeys = {
    CheckIn: '_CheckIn'
}